module.exports = __webpack_public_path__ + "img/36_56.2d2f6aba.png";